import React from "react";
import { Box } from "@mui/material";
import LGModalCrud from "../LGCrud/LGModalCrud";
import FinishedGoodForm from "./FinishedGoodForm";
import QualityControlView from "./QualityControlView";
import {
  getFinishedGoodList,
  deleteFinishedGood,
} from "../../api/finishedGoods";
import QCReportHeaderForm from "./QCReportHeaderForm";
import QCReportSheetModal from "./QCReportSheetModal.tsx";
import QCReportSheet from "./QCReportSheet";
import CrudSpecificationItems from "./CrudSpecificationItems";

// Placeholder component for quality control view
// const QualityControlView = () => {
//   return (
//     <Box>
//       {/* Quality control content will go here */}
//     </Box>
//   );
// };

export default function CrudFinishedGoods({ props }) {
  const { companyId } = props;

  const columns = [
    {
      field: "name",
      headerName: "Nombre",
      flex: 0.7,
      filterable: true,
    },
    {
      field: "code",
      headerName: "Clave",
      flex: 0.3,
      filterable: true,
    },
  ];

  return (
    <Box width={"100%"}>
      <LGModalCrud
        props={{
          fetchFunction: getFinishedGoodList,
          deleteFunction: deleteFinishedGood,
          data: { companyId },
          columns: columns,
          search: true,
          addModalData: {
            header: "Agregar Producto Terminado",
            body: <FinishedGoodForm companyId={companyId} />,
          },
          editModalData: {
            header: "Editar Producto Terminado",
            body: <FinishedGoodForm companyId={companyId} />,
          },
          actions: ["create", "update", "delete", "detail"],
          detailMenu: [
            {
              label: "Control de calidad",
              handler: () => {},
              header: "Control de calidad",
              body: <QualityControlView />,
            },
            {
              label: "Generar Reporte",
              handler: () => {},
              header: "Generar Reporte de Control de Calidad",
              body: <QCReportHeaderForm />,
            },
            {
              label: "Especificaciones",
              handler: () => {},
              header: "Especificaciones del Producto",
              body: <CrudSpecificationItems />,
            }
          ],
        }}
      />
    </Box>
  );
}
